import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addWarningPage() {
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (app.session.user && user && (app.session.user.canViewWarnings() || user.id() === app.session.user.id() && user.visibleWarningCount() > 0)) {
      items.add('warnings', m(LinkButton, {
        href: app.route('user.warnings', {
          username: user.slug()
        }),
        icon: "fas fa-exclamation-circle"
      }, app.translator.trans('fof-moderator-warnings.forum.user.warnings'), user.visibleWarningCount() > 0 ? m("span", {
        className: "Button-badge"
      }, user.visibleWarningCount()) : ''), 10);
    }
  });
}